import Footer from './Footer'
import Header from './Header'
import React from 'react'

export default function index({type,children}) {
  return (
    <>
    <Header type={type}/>
    <main>
    {children}
    </main>
    <Footer/>
    </>
  )
}
